"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmlsCarousel = void 0;
const react_1 = __importStar(require("react"));
const react_elastic_carousel_1 = __importDefault(require("react-elastic-carousel"));
const className_1 = require("../../utils/className");
const CarouselItem_1 = require("./CarouselItem");
const breakPoints = [
    { width: 1, itemsToShow: 1, itemsToScroll: 1 },
    { width: 768, itemsToShow: 4, itemsToScroll: 4 },
];
exports.SmlsCarousel = ({ className = 'smls-carousel', itemPadding = [0, 10], items, }) => {
    const [cards] = react_1.useState([...items]);
    return (react_1.default.createElement(react_elastic_carousel_1.default, { className: className_1.mapToCssModules([className]), breakPoints: breakPoints, itemPadding: itemPadding, pagination: false }, cards.map((card) => (react_1.default.createElement(CarouselItem_1.CarouselItem, { key: card.id, text: card.text, url: card.url })))));
};
//# sourceMappingURL=index.js.map